import { FC, useEffect, useState } from "react";
import { AppCSS, Spacer, TapButton, TxtInput } from "../../../../components";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";
import { TinyLbl } from "../../../../components/labels/labels.styled";
import { Project } from "../../../../redux/types";
import { toast } from "react-toastify";
import { EstimateAddOns } from "../../../../redux/types/Estimate";
import { Prompt } from "../../../../components/dialogue/Dialogue";
import { ProjectAddOns } from "../../../../components/ProjectAddOns";
import InsuranceScopeTap, { TabConfig } from "./InsuranceScopeTab";
import MaterialsDisplay from "../../../../components/share/MaterialDisplay";
//import LaborsDisplay from "../../../../components/share/LaborsDisplay";
import InsuranceScopeViewer from "../../../../components/ui/InsuranceScopeViewer";
import {
  useAddProjectMaterialMeasurement,
  useApproveProjectScope,
} from "../../../../apolloClient/hooks/general/createHook";
import {
  CustomerProjectDetails,
  ProjectMeasurementInput,
} from "../../../../redux/types/projectDetails";
import { extractMeasurementsData } from "../../../../utils/project";
import { FormProvider, useForm } from "react-hook-form";
import Materials from "./Materials";
import Labor from "./Labor";
import Addons from "./Addons";
import InsuranceInfo from "./InsuranceDetails";
import ProjectMeasurement from "./ProjectMeasurement";
import { Autocomplete, Box, TextField } from "@mui/material";
import { logEvent, PROJECT_EVENTS } from "../../../../utils/amplitude";

interface InsuranceProps {
  estimateAddOns?: EstimateAddOns[];
  project?: Project;
  insuranceScopeUrl?: string;
  insuranceScopeDetails: any;
  customerProjectDetails: CustomerProjectDetails;
  handleRefetchProjectDetails: Function;
  permissions?: boolean;
}

export const InsuranceDetails: FC<InsuranceProps> = ({
  project,
  estimateAddOns,
  insuranceScopeUrl,
  insuranceScopeDetails,
  customerProjectDetails,
  handleRefetchProjectDetails,
  permissions = true,
}) => {
  const [insuranceScope, setInsuranceScope] = useState<any>(
    insuranceScopeDetails
  );
  const [isMaterialsCategoryEdit, setIsMaterialsCategoryEdit] = useState(false);
  const [approved, setApproved] = useState(false);
  const [actionType, setActionType] = useState("save");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const { approveScope } = useApproveProjectScope();
  const { addProjectMaterialMeasurement } = useAddProjectMaterialMeasurement();
  const [materialsFocused, setMaterialsFocused] = useState(true);
  const [laborFocused, setLaborFocused] = useState(false);

  const [insuranceFocused, setInsuranceFocused] = useState(false);

  const [addonsFocused, setAddonsFocused] = useState(false);
  
  const [measurementFocused, setMeasurementFocused] = useState(false);

  const [isFormDirty, setIsFormDirty] = useState(false);

  useEffect(() => {
    handleRefetchProjectDetails();
  }, []);

  const documents = customerProjectDetails?.documents || [];

  const insuranceDocuments = documents.filter(
    (doc) => doc.type === "INSURANCE"
  );

  const insuranceDocumentsOptions = insuranceDocuments.map((doc) => ({
    id: doc.id,
    label: `Document ID: ${doc.id}`,
    url: doc.url,
  }));

  const handleDocumentSelect = (event, newValue) => {
    if (newValue) {
      window.open(newValue.url, "_blank");
    }
  };

  const switchActiveTab = (activetab: string) => {
    switch (activetab) {
      case "materials":
        setMaterialsFocused(true);
        setLaborFocused(false);
        setInsuranceFocused(false);
        setAddonsFocused(false);
        setMeasurementFocused(false);
        break;
      case "labor":
        setMaterialsFocused(false);
        setLaborFocused(true);
        setInsuranceFocused(false);
        setAddonsFocused(false);
        setMeasurementFocused(false);
        break;
      case "insurance":
        setMaterialsFocused(false);
        setLaborFocused(false);
        setInsuranceFocused(true);
        setAddonsFocused(false);
        setMeasurementFocused(false);
        break;
      case "addons":
        setMaterialsFocused(false);
        setLaborFocused(false);
        setInsuranceFocused(false);
        setAddonsFocused(true);
        setMeasurementFocused(false);
        break;
      case "measurement":
        setMaterialsFocused(false);
        setLaborFocused(false);
        setInsuranceFocused(false);
        setAddonsFocused(false);
        setMeasurementFocused(true);
        break;
      default:
        break;
    }
  };

  const methods = useForm({
    defaultValues: {
      materialMeasurements:
        insuranceScopeDetails?.materialMeasurements?.map(
          (materialCategory: any) => ({
            measurements:
              materialCategory?.measurements?.map((measurement: any) => ({
                quantity: measurement?.value?.quantity || null,
              })) || [],
          })
        ) || [],
    },
  });

  if (!insuranceScope) {
    return <div>Loading...</div>;
  }

  // const handleConfirm = () => {
  //   switch (actionType) {
  //     case "save":
  //       methods.handleSubmit(OnSaveData)();
  //       break;
  //     case "approve":
  //       onTapApproveScope();
  //       break;
  //     default:
  //       console.log("No action defined.");
  //   }
  // };

  const onClickApprove = () => {
    setOpenConfirm(true);
    setConfirmationMessage("Approve Insurance scope?");
    setActionType("approve");
  };

  // const OnSaveData = async (formData: any) => {
  //   const changedInputs: ProjectMeasurementInput[] =
  //     formData.materialMeasurements.flatMap(
  //       (category: any, categoryIndex: number) =>
  //         category.measurements
  //           .map((measurement: any, measurementIndex: number) => {
  //             const original =
  //               insuranceScope.materialMeasurements[categoryIndex].measurements[
  //                 measurementIndex
  //               ].value.quantity;
  //             if (measurement.quantity !== original) {
  //               return {
  //                 projectId: customerProjectDetails.projectId,
  //                 measurementId:
  //                   insuranceScope.materialMeasurements[categoryIndex]
  //                     .measurements[measurementIndex].id,
  //                 quantity: measurement.quantity,
  //               };
  //             }
  //             return null;
  //           })
  //           .filter((input: any) => input !== null)
  //     );

  //   if (changedInputs.length === 0) {
  //     toast("No changes detected", {
  //       type: "info",
  //       position: "top-left",
  //       className: "toast-message",
  //     });
  //     return;
  //   }

  //   const success = await addProjectMaterialMeasurement(changedInputs);
  //   if (success) {
  //     setOpenConfirm(false);
  //     methods.reset(formData);
  //     handleRefetchProjectDetails();
  //     toast("Data saved successfully", {
  //       type: "success",
  //       position: "top-left",
  //       className: "toast-message",
  //     });
  //   } else {
  //     toast("Failed to save data", {
  //       type: "error",
  //       position: "top-left",
  //       className: "toast-message",
  //     });
  //     setOpenConfirm(false);
  //   }
  // };

  const onTapApproveScope = async () => {
    setOpenConfirm(false);

    const result = await approveScope({
      projectId: customerProjectDetails.projectId,
      approved: true,
    });

    if (!result) {
      toast("Failed to approve the project", {
        type: "error",
        position: "top-center",
        className: "toast-message",
      });
      return;
    }
    toast("Project approved successfully", {
      type: "success",
      position: "top-center",
      className: "toast-message",
    });
    
    // Track scope approval
    logEvent(PROJECT_EVENTS.INSURANCE_SCOPE_APPROVED, {
      project_id: customerProjectDetails.projectId,
      timestamp: new Date().toISOString(),
    });
    
    setApproved(true);
  };

  const activeStyle = {
    color: AppCSS.BLUE,
    fontSize: 18,
    width: "fit-content",
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 5,
    paddingBottom: 5,
    cursor: "pointer",
  };

  const inactiveStyle = {
    color: "black",
    fontSize: 18,
    width: "fit-content",
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 5,
    paddingBottom: 5,
    cursor: "pointer",
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Prompt
        message={confirmationMessage}
        onConfirm={onTapApproveScope}
        onClose={() => setOpenConfirm(false)}
        open={openConfirm}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
          justifyContent: "space-between",
          alignItems: { xs: "stretch", md: "center" },
          mb: 3,
        }}
      >
        <Box sx={{ flex: 1, maxWidth: { xs: "100%", md: "400px" } }}>
          <Autocomplete
            disablePortal
            id="insurance-documents-autocomplete"
            options={insuranceDocumentsOptions}
            onChange={handleDocumentSelect}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Insurance Documents"
                size="small"
              />
            )}
          />
        </Box>
        {permissions && (
          <Box
            component="button"
            onClick={onClickApprove}
            disabled={approved}
            sx={{
              px: 3,
              py: 1.5,
              backgroundColor: approved ? "#e5e7eb" : "#4b87ed",
              color: approved ? "#9ca3af" : "white",
              border: approved ? "1px solid #d1d5db" : "1px solid #4b87ed",
              borderRadius: "8px",
              fontSize: 14,
              fontWeight: 500,
              cursor: approved ? "not-allowed" : "pointer",
              transition: "all 0.2s",
              minWidth: { xs: "100%", md: "160px" },
              "&:hover": approved
                ? {}
                : {
                    backgroundColor: "#3a6fd8",
                  },
            }}
          >
            {approved ? "Scope is Approved" : "Approve Scope"}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: { xs: 1, md: 2 },
          borderBottom: "2px solid #e5e7eb",
          mb: 3,
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            height: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#d1d5db",
            borderRadius: "4px",
          },
        }}
      >
        <Box
          onClick={() => switchActiveTab("materials")}
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            fontWeight: materialsFocused ? 600 : 400,
            color: materialsFocused ? "#4b87ed" : "#6b7280",
            borderBottom: materialsFocused ? "3px solid #4b87ed" : "3px solid transparent",
            cursor: "pointer",
            transition: "all 0.2s",
            whiteSpace: "nowrap",
            "&:hover": {
              color: "#4b87ed",
            },
          }}
        >
          Materials
        </Box>
        <Box
          onClick={() => switchActiveTab("labor")}
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            fontWeight: laborFocused ? 600 : 400,
            color: laborFocused ? "#4b87ed" : "#6b7280",
            borderBottom: laborFocused ? "3px solid #4b87ed" : "3px solid transparent",
            cursor: "pointer",
            transition: "all 0.2s",
            whiteSpace: "nowrap",
            "&:hover": {
              color: "#4b87ed",
            },
          }}
        >
          Labor
        </Box>
        <Box
          onClick={() => switchActiveTab("insurance")}
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            fontWeight: insuranceFocused ? 600 : 400,
            color: insuranceFocused ? "#4b87ed" : "#6b7280",
            borderBottom: insuranceFocused ? "3px solid #4b87ed" : "3px solid transparent",
            cursor: "pointer",
            transition: "all 0.2s",
            whiteSpace: "nowrap",
            "&:hover": {
              color: "#4b87ed",
            },
          }}
        >
          Insurance Details
        </Box>
        <Box
          onClick={() => switchActiveTab("addons")}
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            fontWeight: addonsFocused ? 600 : 400,
            color: addonsFocused ? "#4b87ed" : "#6b7280",
            borderBottom: addonsFocused ? "3px solid #4b87ed" : "3px solid transparent",
            cursor: "pointer",
            transition: "all 0.2s",
            whiteSpace: "nowrap",
            "&:hover": {
              color: "#4b87ed",
            },
          }}
        >
          Add-ons
        </Box>
        <Box
          onClick={() => switchActiveTab("measurement")}
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            fontWeight: measurementFocused ? 600 : 400,
            color: measurementFocused ? "#4b87ed" : "#6b7280",
            borderBottom: measurementFocused ? "3px solid #4b87ed" : "3px solid transparent",
            cursor: "pointer",
            transition: "all 0.2s",
            whiteSpace: "nowrap",
            "&:hover": {
              color: "#4b87ed",
            },
          }}
        >
          Project Measurement
        </Box>
      </Box>
      {materialsFocused ? (
        <Materials
          project={customerProjectDetails}
          refetchData={handleRefetchProjectDetails}
          permissions={permissions}
        />
      ) : (
        <></>
      )}
      {laborFocused ? <Labor project={customerProjectDetails} permissions={permissions} /> : <></>}
      {insuranceFocused ? (
        <InsuranceInfo
          project={customerProjectDetails}
          refetchData={handleRefetchProjectDetails}
          permissions={permissions}
        />
      ) : (
        <></>
      )}
      {addonsFocused ? <Addons project={customerProjectDetails} permissions={permissions} /> : <></>}
      {measurementFocused ? (
        <ProjectMeasurement
          project={customerProjectDetails}
          refetchData={handleRefetchProjectDetails}
          permissions={permissions}
        />
      ) : (
        <></>
      )}
    </Box>
  );
};
